import { PropsWithChildren, useCallback, useEffect, useState } from 'react'

import { ChatModalProperties } from './types'
import Modal from './Containers'
import { FormInput, Header, Messaging } from './Components'

const ChatModal = ({
  isOpen,
  isWaiting,
  onOpen,
  onClose,
  onHide,
  onSubmitMessage,
  messages
}: PropsWithChildren<ChatModalProperties>) => {
  const openModal = useCallback(() => {
    if (isOpen && onOpen) {
      onOpen()
    }
  }, [isOpen, onOpen])

  const closeModal = () => {
    if (onClose) {
      onClose()
    }
  }

  const hideModal = () => {
    if (onHide) {
      onHide()
    }
  }

  useEffect(() => {
    const startModal = () => {
      if (isOpen === true) {
        openModal()
      }
    }

    startModal()
  }, [isOpen, openModal])

  if (!isOpen) {
    return null
  }

  return (
    <Modal.Wrapper>
      <Modal.Header>
        <Header onClose={closeModal} onHide={hideModal} />
      </Modal.Header>
      <Modal.Body>
        <Messaging messages={messages ?? []} isWaitingResponse={isWaiting} />
      </Modal.Body>
      <Modal.Footer>
        <FormInput onSubmit={onSubmitMessage} isWaiting={isWaiting} />
      </Modal.Footer>
    </Modal.Wrapper>
  )
}

export default ChatModal
